import React from 'react';
import { useDisclosure } from '@chakra-ui/core';
import { useHistory } from 'react-router-dom';
import { CandidateMessagingViewModal } from '../../../app/components/CandidateMessagingViewModal';
import { useStoreActions, useStoreState } from '../../../models/hooks';

export const CandidateMessagingModal = React.memo(function CandidateMessagingModal() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const history = useHistory();

  const { openCandidateMessagingModal, messagingViewModal, selectedCandidate } = useStoreState((state) => state.todo);
  const { setOpenCandidateMessagingModal, setSelectedTodo, setMessagingViewModal, setSelectedCandidate } = useStoreActions(
    (actions) => actions.todo,
  );

  React.useEffect(() => {
    if (openCandidateMessagingModal) {
      onOpen();
    }
  }, [onOpen, openCandidateMessagingModal]);

  if (!selectedCandidate || !isOpen) return null;

  function handleModalClose() {
    setSelectedTodo(null);
    setMessagingViewModal(false);
    setSelectedCandidate(null);
    setOpenCandidateMessagingModal(false);

    history.push('/dashboard');
    onClose();
  }

  return (
    <CandidateMessagingViewModal
      isOpen={isOpen}
      onClose={handleModalClose}
      currentCandidateId={selectedCandidate}
      messagingViewModal={messagingViewModal}
    />
  );
});
